<div class="modal-header">
  <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" class="modal-title">e-mail de prueba</div>
  <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Sms" class="modal-title">SMS de prueba</div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body" *ngIf="model">
  <h4 [ngClass]="{'email': model.IdCampaignMedia == 1, 'sms': model.IdCampaignMedia == 2}" class="lateral__bar">Campaña: {{model.Title}}</h4>

  <div class="row">
    <div class="col-md-12 mt-2">
      <input *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" type="email" required class="form-control" [(ngModel)]="contact" placeholder="destinatario@renault.com" />
      <input *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Sms" type="text" required pattern="[0-9]{9}" class="form-control" [(ngModel)]="contact" placeholder="555555555" />
      <span class="form-help">Introduce el contacto al que quieras enviar la campaña</span>
    </div>
  </div>

</div>
<div class="modal-footer">
  <button *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" type="button" class="btn btn-blue" (click)="sendTest()"><i class="fa fa-paper-plane-o"></i> Enviar</button>
  <button *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Sms" type="button" class="btn btn-teal" (click)="sendTest()"><i class="fa fa-paper-plane-o"></i> Enviar</button>
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()"><i class="fa fa-times"></i> Cancelar</button>
</div>